import { Component, ErrorInfo, ReactNode } from "react";

type ErrorBoundaryState = { hasError: boolean };

export class AppErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Public site render error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="fatal-error" role="alert">
        <div className="fatal-error-card">
          <img src="/brand/logo-mark.png" alt="" width="84" height="82" />
          <span className="eyebrow">Something went wrong</span>
          <h1>We hit an unexpected problem.</h1>
          <p>The page could not finish loading. You can try again or return to the homepage.</p>
          <div className="fatal-error-actions">
            <button className="btn btn-primary" type="button" onClick={() => window.location.reload()}>Reload the page</button>
            <a className="btn btn-outline" href="/">Return home</a>
          </div>
          <small>If this continues, please contact Triple H using the phone number or email published on our contact page.</small>
        </div>
      </main>
    );
  }
}
